import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {HttpService} from '../../http/http.service';
import {DocumentoNoExigible, IDocumentoNoExigible} from '../../models/documentosObligatorios/idocumentosObligatorios';
import {CGeneralResponse, GeneralResponse} from '../../models/general-response/general-response';
import {DocumentosSolicitudService} from '../Documentos/DocumentosSolicitud.service';

@Injectable({
  providedIn: 'root'
})
export class ObligatoriedadDocumentosService {

  private prefijo = environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL;
  private urlBlob = environment.GESTOR_SOLICITUDES.API_CONSULTAS.DOCUMENTOS_DIGITALES_ENDPOINT;

  public documentosTitular: any[] = [];
  public documentosConyuge: any[] = [];
  public documentosBeneficiario: any[] = [];

  public documentosConyugeSubject = new BehaviorSubject<any[]>([]);
  documentosConyuge$ = this.documentosConyugeSubject.asObservable();

  public documentosBeneficiarioSubject = new BehaviorSubject<any[]>([]);
  documentosBeneficiario$ = this.documentosBeneficiarioSubject.asObservable();

  public documentosBeneficiarioListosSubject = new BehaviorSubject<boolean>(false);
  documentosBeneficiarioListosSubject$ = this.documentosBeneficiarioListosSubject.asObservable();

  public documentosConyugeListosSubject = new BehaviorSubject<boolean>(false);
  documentosConyugeListosSubject$ = this.documentosConyugeListosSubject.asObservable();

  constructor(
    private httpService: HttpService,
    private documentosSolicitudService: DocumentosSolicitudService
  ) {
  }

  getDocumentosDigitalesExistentesDepropietario(
    idTitular: string,
    idBeneficiario: string
  ): Observable<GeneralResponse<IDocumentoNoExigible[]>> {
    const params = {
      identificacionTitular: idTitular,
      identificacionBeneficiario: idBeneficiario
    };

    return this.httpService.get<GeneralResponse<IDocumentoNoExigible[]>>(
      this.prefijo,
      this.urlBlob,
      params
    ).pipe(
      map((response) => {
        const documentosObligatorios: IDocumentoNoExigible[] = response.body.map((item) =>
          DocumentoNoExigible.documentosObligatoiosDesdeObj(item)
        );
        return CGeneralResponse.generalResponseDesdeObj<IDocumentoNoExigible[]>(response, documentosObligatorios);
      })
    );
  }

  async obtenerDocumentosFiltrados(filtro: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const sub = this.documentosSolicitudService.filtrarDocumentos(filtro).subscribe(
        (response) => {
          if (!response || response.length === 0) {
            console.warn('La respuesta está vacía.');
          }

          try {
            const documentosTransformados = this.transformarDocumentosSolicitud(response);
            resolve(documentosTransformados);
          } catch (err) {
            console.error('Error transformando documentos:', err);
            reject(err);
          }
        },
        (error) => {
          console.error('Error en la petición HTTP:', error);
          reject(error);
        }
      );
    });
  }

  transformarDocumentosSolicitud(documentosOriginales: any[]) {
    if (!Array.isArray(documentosOriginales)) {
      console.warn('transformarDocumentosSolicitud recibió un valor no válido:', documentosOriginales);
      return [];
    }

    return documentosOriginales.map((documentoOriginal) => {
      const tipoDoc = documentoOriginal?.documentosDigitalesTipos || {};
      const pesoMaximoKb = tipoDoc.pesoMaximoKb || 2000;

      return {
        id: documentoOriginal.id,
        type: ['.pdf'],
        required: documentoOriginal.esRequerido,
        label: documentoOriginal.etiqueta,
        idForm: documentoOriginal.formularioId,
        maxSizeAttachmentsKb: pesoMaximoKb,
        propietario: documentoOriginal.parentescosEntity?.esBeneficiario ? 'B' : 'T',
        idTipoDocumento: tipoDoc.id
      };
    });
  }

  public limpiarDocumentos(): void {
    this.documentosTitular = [];
  }

  resetearDocumentosConyuge(): void {
    this.documentosConyuge = [];
    this.documentosConyugeSubject.next([]);
    this.documentosConyugeListosSubject.next(false);
  }

  resetearDocumentosBeneficiario(): void {
    this.documentosBeneficiario = [];
    this.documentosBeneficiarioSubject.next([]);
    this.documentosBeneficiarioListosSubject.next(false);
  }
}
